import React from "react";

const Vouchers = () => {
  return (
    <section class="keyzi_content--wrapper">
      <div class="container">
        <div class="keyzi_content--inner">
          <div class="row">
            <div class="col-md-6">
              <div class="card p-4">
                <h4>Why Driving Lesson Vouchers Are Great:</h4>
                <ul>
                  <li>Easy to buy online</li>
                  <li>Perfect for birthdays or holidays</li>
                  <li>Help someone gain a valuable life skill</li>
                  <li>Show you care about their future</li>
                </ul>
                <h4>How It Works:</h4>
                <ul>
                  <li>Choose how many lessons to gift</li>
                  <li>Pay securely on our website</li>
                  <li>We send a digital voucher to you or your friend</li>
                  <li>They book lessons using our app</li>
                </ul>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card p-4">
                <h4>Why Choose Our Driving School:</h4>
                <ul>
                  <li>Top-rated instructors</li>
                  <li>Flexible scheduling</li>
                  <li>Learn in a safe, friendly environment</li>
                  <li>Track progress in the app</li>
                </ul>
                <p>
                  Driving isn't just about getting around. It's about freedom
                  and new opportunities. Give someone the chance to:
                </p>
                <ul>
                  <li>Get to work or school easily</li>
                  <li>Go on fun road trips</li>
                  <li>Feel more independent</li>
                </ul>
                <p>
                  Your gift will be remembered every time they get behind the
                  wheel!
                </p>
                <a href="#banner-gift" class="btn btn-primary">
                  Buy a Voucher Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vouchers;
